
import EventList from './components/activity.vue';
import mEventList from './components/mActivity.vue';
import redEnvelope from './components/redEnvelope.vue';
import rebate from './components/rebate.vue';
import vip from './components/vip.vue';
import Rolls from './components/rolls';
import freebox from './components/freebox';
import subsidy from './components/subsidy.vue';
import { mapState, mapMutations } from "vuex";

export default {
	components: {
		'c-eventList':EventList,
		'c-m-eventList':mEventList,
		'c-redEnvelope':redEnvelope,
		'c-rebate':rebate,
		'c-vip':vip,
		'c-rolls':Rolls,
		'c-freebox':freebox,
		'c-subsidy':subsidy
	},
	props: {
		welfareCat: {
		  type: Number
		},
	},
	data(){
		return {
			category: 0,
		}
	},
	methods: {
		async on_close_button_click(event) {
			this.$emit('close_button_click', event);
		}
	},
	computed: {
		...mapState(["user"]),
	},
	created() {
	},
	watch: {
		welfareCat(newValue) {
		  this.category = newValue
		},
	},
}